import _ from 'lodash';
import { combineReducers } from 'redux';
import types from 'frontend/state/actionTypes';

import {
  secondaryBonuses,
  gems,
  gemInfo,
  enchants,
} from 'shared/items';

import GameData from 'shared/gameData';

import itemReducer from './item';

const idReducer = (state = 0, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_GEARSET:
      return payload.gearsetId;
    default:
      return state;
  }
};

const nameReducer = (state = '', action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_GEARSET_NAME:
      return payload.name;
    default:
      return state;
  }
};

const initialState = [];

const itemsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_ITEM:
    case types.ADD_GEARSET:
      return [
        ...state,
        itemReducer(undefined, action),
      ];
    case types.REMOVE_ITEM:
      return _.reject(state, { id: payload.itemId });
    case types.INPUT_ITEM:
    case types.INPUT_ITEM_SLOT:
    case types.INPUT_ITEM_LEVEL:
    case types.INPUT_ITEM_GEM:
    case types.INPUT_ITEM_GEM_LEVEL:
    case types.INPUT_ITEM_ENCHANT:
    case types.INPUT_ITEM_SECONDARY:
    case types.INPUT_ITEM_AFFIX:
    case types.INPUT_ITEM_HAND:
    case types.INPUT_ITEM_AZERITE_POWER:
    case types.INPUT_ITEM_CORRUPTION:
    case types.INPUT_ITEM_LEGENDARY_POWER:
    case types.INPUT_ITEM_LEGENDARY_STATS:
    case types.INPUT_ITEM_CRAFTED_STATS:
      return state.map((item) => {
        if (item.id === payload.itemId) {
          return itemReducer(item, action);
        }
        return item;
      });
    case types.SUBMIT_SIM_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default combineReducers({
  id: idReducer,
  name: nameReducer,
  items: itemsReducer,
});

export const gearsetDefaultName = gearset => {
  const { items } = gearset;

  if (items && items.length === 1 && items[0].item) {
    const {
      item,
      itemLevel,
      itemSecondary,
      itemAffix,
      itemSlot,
      itemHand,
      itemGem, // legacy
      itemGem0,
      itemGem1,
      itemGem2,
      itemEnchant,
      legendaryPower,
      legendaryStats,
      craftedStats,
    } = items[0];

    // single item compare name
    let title = item.name || '';
    if (itemAffix) {
      title += ` ${GameData.BonusAffixNames[itemAffix]}`;
    }
    if (itemLevel) {
      title += ` ${itemLevel}`;
    }
    if (itemSecondary) {
      const secondaryInfo = _.find(secondaryBonuses, { bonusId: itemSecondary });
      title += ` ${secondaryInfo.name}`;
    }
    const extraTitle = [];
    if (itemSlot) {
      const slotNum = itemSlot.substring(itemSlot.length - 1);
      extraTitle.push(`Slot ${slotNum}`);
    }
    if (itemHand) {
      extraTitle.push(itemHand === 'main_hand' ? 'Main Hand' : 'Off Hand');
    }
    if (legendaryPower) {
      const power = _.find(GameData.LegendaryAbilities, { id_bonus: legendaryPower });
      extraTitle.push(power.name);
    }
    if (legendaryStats) {
      extraTitle.push(_.join(_.map(_.split(legendaryStats, ','), _.startCase), ' + '));
    }
    if (craftedStats) {
      extraTitle.push(_.join(_.map(_.split(craftedStats, ','), _.startCase), ' + '));
    }
    if (itemGem) {
      extraTitle.push(gems[itemGem]);
    }
    if (itemEnchant) {
      const enchant = _.find(enchants, { key: itemEnchant });
      if (enchant) {
        extraTitle.push(enchant.name);
      }
    }
    _.each([itemGem0, itemGem1, itemGem2].filter(g => g), (gem, idx) => {
      if (Number.isNaN(Number(gem))) {
        extraTitle.push(gems[gem]);
      } else {
        const gemData = _.find(gemInfo, { id: Number(gem) });
        let gemTitle = gemData.name;
        const levelField = `itemGemLevel${idx}`;
        if (items[0][levelField]) {
          gemTitle += ` ${items[0][levelField]}`;
        }
        extraTitle.push(gemTitle);
      }
    });
    if (extraTitle.length > 0) {
      title += ` (${extraTitle.join(' / ')})`;
    }

    return title.replace(/[,"]/g, '');
  } if (items && items.length > 1) {
    return _.map(
      _.filter(items, item => item.item), // remove empty items
      item => {
        let str = `${item.item.name} ${item.itemLevel}`;
        if (item.itemSlot) {
          const slotNum = item.itemSlot.substring(item.itemSlot.length - 1);
          str += ` Slot ${slotNum}`;
        }
        if (item.itemHand) {
          str += ` ${item.itemHand === 'main_hand' ? 'MH' : 'OH'}`;
        }
        return str;
      },
    ).join(' / ').replace(/[,"]/g, '');
  }

  return 'Gearset Name';
};
